import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {InContextHelpMessage} from '@communityshare/ui-shared';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import {DialogManager} from '@/dialogs_new/DialogManager';
import useIsEventShareable from '@/features/share-event/hooks/useIsEventShareable';

EventShareCallout.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      published: PropTypes.bool
    })
  }).isRequired
};

export default function EventShareCallout(props) {
  const {event} = props;
  const {t} = useTranslation();
  const launch = useDialogLauncher();
  const isShareable = useIsEventShareable(event);

  if (!isShareable) {
    return null;
  }

  return (
    <InContextHelpMessage
      boldText={t('event_share.more_partners_bold')}
      bodyText={t('event_share.more_partners_body')}
      linkLabel={t('event_share.share_link')}
      onLinkClick={() => launch(DialogManager.EventShare.Config(event.id, 'manage'))}
    />
  );
}
